interface SelectableAsset {
  id: string;
  name: string;
  type?: string;
}

/**
 * Asset picker cards are shared by video and graphic flows. Keep their reply
 * content-neutral so confirming carousel images cannot accidentally turn the
 * conversation into a video-edit request.
 */
export function buildAssetPickerSelectionMessage(
  assets: SelectableAsset[],
  selectedIds: string[]
): string {
  const assetMap = new Map(assets.map((asset) => [asset.id, asset.name]));
  const lines = selectedIds.map(
    (id) => `- ${assetMap.get(id) ?? 'Untitled'} (${id})`
  );
  const libraryType =
    assets.length && assets.every((asset) => asset.type === assets[0].type)
      ? assets[0].type
      : undefined;
  const selectedTypes = selectedIds.map(
    (id) => assets.find((asset) => asset.id === id)?.type ?? libraryType
  );
  const kind =
    selectedTypes.length && selectedTypes.every((type) => type === 'image')
      ? 'photos'
      : selectedTypes.length && selectedTypes.every((type) => type === 'video')
        ? 'clips'
        : 'items';
  return `Use these ${kind}:\n${lines.join('\n')}`;
}
